<div class="flex flex-col gap-2">
  @for (option of formArray.controls; track $index) {
    @if (option.get('state')?.value !== 'delete') {
      <div class="flex items-center gap-2" [formGroup]="getOptionControl($index)">
        <mat-form-field appearance="outline" class="flex-grow">
          <mat-label>Option Name</mat-label>
          <input matInput formControlName="addon_name" required class="text-sm">
          @if (option.get('addon_name')?.errors?.['required'] && option.get('addon_name')?.touched) {
            <mat-error class="text-xs">Required</mat-error>
          }
          @if (option.get('addon_name')?.errors?.['duplicateName'] && option.get('addon_name')?.touched) {
            <mat-error class="text-xs">There is another option with this name, please choose another name</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-24">
          <mat-label>Price</mat-label>
          <input matInput type="number" formControlName="price" required class="text-sm"
            [placeholder]="isRequestQuote ? 'N/A' : ''" />
          @if (isRequestQuote) {
            <mat-hint class="text-amber-600 text-xs">N/A</mat-hint>
          }
          @if (!isRequestQuote && option.get('price')?.errors?.['required'] && option.get('price')?.touched) {
            <mat-error class="text-xs">Required</mat-error>
          }
          @if (!isRequestQuote && option.get('price')?.errors?.['min'] && option.get('price')?.touched) {
            <mat-error class="text-xs">Min 0.01</mat-error>
          }
        </mat-form-field>

        <!-- The bag / box it ships in; choosing it fills the markup in from the
             vendor's table for this country. The markup stays editable. -->
        <mat-form-field appearance="outline" class="w-56">
          <mat-label>Transhipment Packing Size</mat-label>
          <mat-select
            formControlName="packing_size"
            (selectionChange)="onSizeChange($index, $event.value)"
          >
            <mat-option [value]="null">Not set</mat-option>
            @for (size of packingSizes; track size.key) {
              <mat-option [value]="size.key">{{ size.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-36">
          <mat-label>Transhipper Markup</mat-label>
          <input matInput type="number" min="0" formControlName="destination_transhipper_markup" class="text-sm" />
          @if (option.get('destination_transhipper_markup')?.errors?.['min']) {
            <mat-error class="text-xs">Cannot be negative</mat-error>
          }
        </mat-form-field>

        <button mat-icon-button color="warn" class="flex-shrink-0 -mt-3" (click)="triggerRemoveOption($index)">
          <mat-icon class="text-base">delete</mat-icon>
        </button>
      </div>
    }
  }

  <div class="flex justify-end">
    <button mat-icon-button color="primary" (click)="triggerAddOption()" class="add-option-btn">
      <mat-icon>add_circle</mat-icon>
    </button>
  </div>
</div>
